exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2VuXjZvBBBdnzM{background-color:#fdfae5;background-image:linear-gradient(to bottom right,rgba(0,0,0,.05) 25%,transparent 0,transparent 50%,rgba(0,0,0,.05) 0,rgba(0,0,0,.05) 75%,transparent 0,transparent);background-size:14px 14px;min-height:30px;padding:12px 12px 12px 50px;position:relative}._2VuXjZvBBBdnzM ._39T1FO0zt8OK6x{position:absolute;top:12px;left:12px}._2VuXjZvBBBdnzM ._3dwJeJOl6obszp{font-size:16px;line-height:30px;margin:0}", ""]);

// exports
exports.locals = {
	"archivedBanner": "_2VuXjZvBBBdnzM",
	"archiveBannerIcon": "_39T1FO0zt8OK6x",
	"archivedBannerText": "_3dwJeJOl6obszp"
};